import React from 'react';
import { motion } from 'framer-motion';
import { Link } from "react-router-dom";

import bgPattern from '../assets/img/detail/bg_pattern.png';

import '../assets/scss/components/pageNotFound.scss';

export default function PageNotFound() {
  return (
    <div className="page-detail not-found">
      <div className="detail">
        <div className="detail__inner">
          <motion.div
            className="detail__content"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { delay: 1, duration: 0.3, ease: 'linear' } }}>
              <div className="not-found__body">
                <h1 className="not-found__heading"><span>404</span></h1>
                <p className="not-found__subheading">ページが見つかりませんでした</p>
                <div className="detail__btn detail__btn--md"><Link to="/"><span>トップに戻る</span></Link></div>
              </div>
          </motion.div>
          <div className="detail__pattern" style={{ backgroundImage: `url(${bgPattern})` }}></div>
        </div>
      </div>
    </div>
  )
}